import PropTypes from 'prop-types';

const context = {
  page: PropTypes.shape({
    constrainHeight: PropTypes.bool,
  }),
};

export default context;
